import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(
  ({ spacing, palette, breakpoints }: Theme) => ({
    errorWrapper: {
      maxWidth: '550px',
    },

    errorPage: {
      textAlign: 'center',
    },

    errorLogo: {
      position: 'fixed',
      top: spacing['5'],
      left: spacing['5'],
      margin: 0,
      width: 200,
      height: 30,

      [`@media (max-width: ${breakpoints.sm}px)`]: {
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
        backgroundColor: palette.background.main,
      },
    },
  })
);

export default useStyles;
